import request from "@/utils/request";

export function updateImage(formData) {
  // const formData = new FormData();
  // formData.append('file', file);
  return request({
    url: "/api/mts-api/upload/image",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data", // 确保请求头是 multipart/form-data
    },
  });
}

export function updateVideo(formData) {
  return request({
    url: "/api/mts-api/upload/video",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 新的文件上传接口，支持remark参数
export function uploadFile(data) {
  return request({
    url: "/api/mts-api/ai/document/upload",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 文件上传接口
export function updateFile(formData) {
  return request({
    url: "/api/mts-api/upload/file",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
// 文件上传接口
export function updateCommon(formData) {
  return request({
    url: "/api/mts-api/upload/common",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function downloadCommonFile(params) {
  return request({
    url: "/api/mts-api/upload/download",
    method: "get",
    params,
    responseType: "blob",
  });
}
